const config = {
  apiURL: 'https://api-paper.jbaubree.fr/',
  maxMobileSize: 575,
  DEFAULT_THEME_COLOR: '#d86077',
};

export default config;
